import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../services/User.service';
import { UserLoginModel } from '../model/user-login-model';
import { CityState, VendorsignUpModel } from '../model/vendorsign-up-model';
import { ReadVarExpr, THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { CrudService } from '../services/crud.service';
import { VMS_Notification } from '../model/notification.model';
import { NotificationService } from '../services/notification.service';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})

export class SigninComponent implements OnInit {
  user: UserLoginModel = new UserLoginModel();
  ForgotPassModel: UserLoginModel = new UserLoginModel();
  Newpassword: any = "";
  DisableResetButton: boolean = false;
  DisableMailButton: boolean = false;
  DisableValidateButton: boolean = false;
  ShowRegisterScreen: boolean = false;
  vendorRegModel: VendorsignUpModel = new VendorsignUpModel();
  public message: string;
  public progress: number;
  enable: boolean;
  fileToUpload: File = null;
  StateList: any[] = [];
  PostCodeList: any[] = [];
  StateNavList: any[] = [];
  downloadBaseURL :string;

  @ViewChild('closeRegisterModal', { static: false }) closeAddExpenseModal: ElementRef;
  @ViewChild('DeclarationFile', { static: false }) TDSFile: ElementRef;
  @ViewChild('MSMSECertificateFile', { static: false }) CertificateFile: ElementRef;

  
  constructor(private toastr: ToastrService, private router: Router,
    private http: HttpClient,
    private loginSer: LoginService, private _CrudSer: CrudService,private notificationSer: NotificationService) { 

      this.downloadBaseURL = this.notificationSer.GetDownloadBaseURL();
    }

  ngOnInit() {
    this.GetPageNotifications(1);
    this.GteCityAndStateList();
    this.GetState();
    this.GetPostCode();
    this.GetDepartment();
    this.GetVendorDetails();
  }

  IsDisable: boolean = false;

  RegisterVendor() {

    var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!regex.test(this.vendorRegModel.PANNo)) {
      this.toastr.warning("Invalid pan no");
      return;
    }

    if (!(this.validate())) {
      return;
    }
    if (this.vendorRegModel.Post_Code.length! < 6) {
      this.toastr.warning('Please Check Postal Code ');
      return;
    }

    if (!(this.validateEmail())) {
      this.toastr.error("Email address is invalid");
      return;
    }

    this.vendorRegModel.Name = this.vendorRegModel.ContactPerson;

 

    
    if (this.vendorRegModel.VendorCode != '')
      this.vendorRegModel.ToCreateOrderAdress = true;
    else this.vendorRegModel.ToCreateOrderAdress = false;
    console.log(this.vendorRegModel);

    debugger;
    if (this.vendorRegModel.MSMEType == "Micro" || this.vendorRegModel.MSMEType == "Small" || this.vendorRegModel.MSMEType == "Medium") {
      if (this.vendorRegModel.MSMERegistrationDate == '') {       
        this.toastr.error("Please Enter Registration Date");
       return;
      }
      else if(!this.msmeUpload)
      {
        this.toastr.error("Please Upload MSME Certificate");
        return;
      }
    }


    this.IsDisable = true;
    this.loginSer.RegisterVendor(this.vendorRegModel).subscribe(
      data => {
        
        this.IsDisable = false;
       
        if (data.Message == "Thank you for submitting the Record.VHD will contact you soon") {
          document.getElementById('btnRegClose').click();
          //this.closeAddExpenseModal.nativeElement.hidden = true;
          this.toastr.success("Your Request has been Submitted.VHD will contact you Soon");
          //location.href = "/";
        }
        else {
          this.toastr.error(data.Message);
        }

      },
      error => {
        console.log(error);
        this.IsDisable = false;
      }
    );
  }


  alphaNumberOnly(e) { 
     // Accept only alpha numerics, not special characters 

     

    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }

  NumberOnly(e) {  // Accept only alpha numerics, not special characters 
    var regex = new RegExp("^[0-9]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }



  UnRegisteredChange() {

    if (this.vendorRegModel.UnRegistered) {
      this.vendorRegModel.GSTVendorType = "UnRegistered";

      if (this.vendorRegModel.GSTNo != '') {
        if (confirm('Are you sure for Un-Registered Vendor?')) {
          this.vendorRegModel.GSTNo = '';
        }
        else {
          
          this.vendorRegModel.UnRegistered = false;
          (<HTMLInputElement>document.getElementById("chkUnRegistered")).checked = false;
          this.vendorRegModel.GSTVendorType = "";
        }
      }
    }
    else {
      this.vendorRegModel.GSTVendorType = "";
      this.vendorRegModel.UnRegistered = false;
    }
  }

  GstType: string;
  CheckExistingVendor() {
    // this.ShowRegisterScreen = true;
    // return;

    

    if (this.vendorRegModel.ContactPerson == '' || this.vendorRegModel.ContactPerson == undefined || this.vendorRegModel.ContactPerson == null) {
      this.toastr.warning("Please Enter Contact Person");
      return;
    }
    if (this.vendorRegModel.MobileNo == '' || this.vendorRegModel.MobileNo == undefined || this.vendorRegModel.MobileNo == null) {
      this.toastr.warning("Please Enter Mobile No.");
      return;
    }
    if (this.vendorRegModel.MobileNo.length < 10) {
      this.toastr.warning("Please Enter 10 Digit Mobile No.");
      return;
    }
    if (this.vendorRegModel.Email == '' || this.vendorRegModel.Email == undefined || this.vendorRegModel.Email == null) {
      this.toastr.warning("Please Enter Email");
      return;
    }

    if (!(this.validateEmail())) {
      this.toastr.error("Email address is invalid");
      return;
    }

    this.vendorRegModel.PANNo = this.vendorRegModel.PANNo.toUpperCase();
    this.vendorRegModel.GSTNo = this.vendorRegModel.GSTNo.toUpperCase();

    if (this.vendorRegModel.PANNo == "") {
      this.toastr.warning('Please Enter PAN Number');
      return;
    }
    else if (this.vendorRegModel.PANNo != "") {
      var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!regex.test(this.vendorRegModel.PANNo)) {
        this.toastr.warning("Invalid pan no");
        return;
      }
    }

    

    if (this.vendorRegModel.UnRegistered == false) {
      if (this.vendorRegModel.GSTNo == "") {
        this.toastr.warning('Please Enter GST Number');
        return;
      }
      if (this.vendorRegModel.GSTNo.length != 15) {
        this.toastr.warning('GST Number must be 15 Characters.');
        return;
      }
      else if (!this.vendorRegModel.GSTNo.includes(this.vendorRegModel.PANNo)) {
        this.toastr.warning("Invalid GST Number.");
        return;
      }
      else if (this.vendorRegModel.GSTNo.length == 15) {
        let stateCode = this.vendorRegModel.GSTNo.substring(0, 2);
        let b = this.vendorRegModel.GSTNo.substring(2, 12);
        let GSTLast = this.vendorRegModel.GSTNo.substring(12);
        var regexNum = /[0-9]{2}$/;
        var regexGSTLast = /[0-9A-Z]{3}$/;

        if (b != this.vendorRegModel.PANNo) {
          this.toastr.warning("Invalid GST Number.");
          return
        }
        else if (!regexNum.test(stateCode)) {
          this.toastr.warning("Invalid State Code in GST No.");
          return;
        }
        else if (!regexGSTLast.test(GSTLast)) {
          this.toastr.warning("Last 3 Chars are invalid in GST No.");
          return;
        }
      }
    }

    //this.ShowRegisterScreen = true;



    this.vendorRegModel.Name = this.vendorRegModel.ContactPerson;
    var data = {
      "VendPANNum": this.vendorRegModel.PANNo,
      "VendCode": this.vendorRegModel.UserName,
      "VendGSTNum": this.vendorRegModel.GSTNo,
      "UnRegistered": this.vendorRegModel.UnRegistered,

      "ContactPerson": this.vendorRegModel.ContactPerson,
      "MobileNo": this.vendorRegModel.MobileNo,
      "Email": this.vendorRegModel.Email,
      "SendEmail": false
    }




    this.DisableValidateButton = true;
    this.loginSer.CheckExistingVendor(data).subscribe(
      data => {
        console.log(data);
        console.log(JSON.stringify(data));

        
        // this.vendorRegModel.VendorCode = data.Data["VendorCode"];
        // this.vendorRegModel.UserName = data.Data["VendorCode"];
        // this.vendorRegModel.ToCreateOrderAdress = data.Data["ToCreateAddress"];

        this.DisableValidateButton = false;
        if (data.Data.Status) {
          

          if (data.Data.Message == 'Inprocess') {
            alert('Record already exist. Please wait for approval.');
          }
          else if (data.Data.Message == 'OrderExist') {
            alert('Record already exist');
          }

          else if (data.Data.Message == 'Process Rejected') {
            alert('Vendor Registration process has been rejected. Please contact to VHD.');
          }
          else if (data.Data.Message == 'Exist') {
            if (confirm('Do you want to get the userid and password for VMS portal. Please contact to VHD.')) {
              var data1 = {

                "VendPANNum": this.vendorRegModel.PANNo,
                "VendCode": this.vendorRegModel.UserName,
                "VendGSTNum": this.vendorRegModel.GSTNo,
                "UnRegistered": this.vendorRegModel.UnRegistered,

                "ContactPerson": this.vendorRegModel.ContactPerson,
                "MobileNo": this.vendorRegModel.MobileNo,
                "Email": this.vendorRegModel.Email,
                "SendEmail": true
              }
              this.loginSer.CheckExistingVendor(data1).subscribe(
                data => {
                  
                  console.log(data1);
                  console.log(data);
                  if (data.Data.Status) {
                    this.DisableValidateButton = false;
                    this.vendorRegModel = new VendorsignUpModel();
                    this.toastr.success("Your request has been submitted. VHD will contact you soon on your registered mail ID: " + data.Data.Data);

                  }
                  else {
                    this.DisableValidateButton = false;
                    this.toastr.error(data.Data.Message);

                  }
                },
                error => {
                  console.log(error);
                  this.DisableValidateButton = false;
                  console.error();
                }
              );

            }
          }

          else {
            if (confirm("Vendor Does Not Exist,Do You want to Register As New Vendor")) {
              
              this.ShowRegisterScreen = true;
              this.DisableValidateButton = true;

            }
          }
        }
        else {
          if (confirm("Vendor Does Not Exist,Do You want to Register As New Vendor")) {
            
            this.ShowRegisterScreen = true;
            this.DisableValidateButton = true;
          }
        }

      },
      error => {
        console.log(error);
        this.DisableValidateButton = false;
        console.error();
      }
    );

  }

  validate() {
    if (this.vendorRegModel.PanFile == '' || this.vendorRegModel.PanFile
      == undefined || this.vendorRegModel.PanFile == null) {
      this.toastr.warning("Please Upload Pan");
      return false;
    }
    if (this.vendorRegModel.CompanyName == '' || this.vendorRegModel.CompanyName
      == undefined || this.vendorRegModel.CompanyName == null) {
      this.toastr.warning("Please Enter Company Name");
      return false;
    }
    if ((this.vendorRegModel.GSTNo == '' || this.vendorRegModel.GSTNo
      == undefined || this.vendorRegModel.GSTNo == null) && this.vendorRegModel.UnRegistered == false) {
      this.toastr.warning("Please Enter Gst Number");
      return false;
    }

    if (this.vendorRegModel.Address1 == '' || this.vendorRegModel.Address1
      == undefined || this.vendorRegModel.Address1 == null) {
      this.toastr.warning("Please Enter Address 1");
      return false;
    }
    if (this.vendorRegModel.Address2 == '' || this.vendorRegModel.Address2
      == undefined || this.vendorRegModel.Address2 == null) {
      this.toastr.warning("Please Enter Address 2");
      return false;
    }
    if (this.vendorRegModel.City_Code == '' || this.vendorRegModel.City_Code
      == undefined || this.vendorRegModel.City_Code == null) {
      this.toastr.warning("Please Select City Name");
      return false;
    }
    if (this.vendorRegModel.Post_Code == '' || this.vendorRegModel.Post_Code
      == undefined || this.vendorRegModel.Post_Code == null) {
      this.toastr.warning("Please Enter Post Code");
      return false;
    }
    if (this.vendorRegModel.ContactPerson == '' || this.vendorRegModel.ContactPerson
      == undefined || this.vendorRegModel.ContactPerson == null) {
      this.toastr.warning("Please Enter Contact Person");
      return false;
    }
    if (this.vendorRegModel.MobileNo == '' || this.vendorRegModel.MobileNo
      == undefined || this.vendorRegModel.MobileNo == null) {
      this.toastr.warning("Please Enter Mobile No.");
      return false;
    }
    if (this.vendorRegModel.Email == '' || this.vendorRegModel.Email
      == undefined || this.vendorRegModel.Email == null) {
      this.toastr.warning("Please Enter Email");
      return false;
    }

    if (this.vendorRegModel.State_Code == '' || this.vendorRegModel.State_Code
      == undefined || this.vendorRegModel.State_Code == null) {
      this.toastr.warning("Please Select State");
      return false;
    }

    if (this.vendorRegModel.GSTVendorType == '' || this.vendorRegModel.GSTVendorType
      == undefined || this.vendorRegModel.GSTVendorType == null) {
      this.toastr.warning("Please Enter GST Type");
      return false;
    }
    
    if ((this.vendorRegModel.RegisteredFile == '' || this.vendorRegModel.RegisteredFile
      == undefined || this.vendorRegModel.RegisteredFile == null) && this.vendorRegModel.GSTVendorType == 'Registered') {
      this.toastr.warning("Please Upload GST Registered File");
      return false;
    }

    // if(this.vendorRegModel.RegisterWith == '' || this.vendorRegModel.RegisterWith
    // == undefined || this.vendorRegModel.RegisterWith == null){
    //   this.toastr.warning("Please Enter MSME");
    //   return false; 
    // } 

    if (this.vendorRegModel.BankAccNumber == '' || this.vendorRegModel.BankAccNumber
      == undefined || this.vendorRegModel.BankAccNumber == null) {
      this.toastr.warning("Please Enter Bank Account No");
      return false;
    }
    if (this.vendorRegModel.BankIFSCCode == '' || this.vendorRegModel.BankIFSCCode
      == undefined || this.vendorRegModel.BankIFSCCode == null) {
      this.toastr.warning("Please Enter IFSC Code");
      return false;
    }
    if (this.vendorRegModel.BankName == '' || this.vendorRegModel.BankName
      == undefined || this.vendorRegModel.BankName == null) {
      this.toastr.warning("Please Enter Name");
      return false;
    }
    if (this.vendorRegModel.ChequeFile == '' || this.vendorRegModel.ChequeFile
      == undefined || this.vendorRegModel.ChequeFile == null) {
      this.toastr.warning("Please Upload Cheque");
      return false;
    }
    if (this.vendorRegModel.BankAddress == '' || this.vendorRegModel.BankAddress
      == undefined || this.vendorRegModel.BankAddress == null) {
      this.toastr.warning("Please Enter Address");
      return false;
    }
    if (this.vendorRegModel.BankAddress2 == '' || this.vendorRegModel.BankAddress2
      == undefined || this.vendorRegModel.BankAddress2 == null) {
      this.toastr.warning("Please Enter Address_2");
      return false;
    }
    if (this.vendorRegModel.BankCity == '' || this.vendorRegModel.BankCity
      == undefined || this.vendorRegModel.BankCity == null) {
      this.toastr.warning("Please Select City");
      return false;
    }
    if (this.vendorRegModel.BankPostCode == '' || this.vendorRegModel.BankPostCode
      == undefined || this.vendorRegModel.BankPostCode == null) {
      this.toastr.warning("Please Enter Bank Post Code");
      return false;
    }

    else {
      return true;
    }
  }
  validateEmail() {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(this.vendorRegModel.Email).toLowerCase());
  }
  ValidateVendorDetails() {
  }

  ClearForgotMessage(){
    this.ForgotMessage=false;
    this.ForgotMessageContent="";
  }
  ClearModalPopUP() {
    this.ClearForgotMessage();
    this.user = new UserLoginModel();
    this.ForgotPassModel = new UserLoginModel();
  }
  ClearModalRegister() {
    this.vendorRegModel = new VendorsignUpModel();
  }
  reset() {
    this.ShowRegisterScreen = false;
    this.DisableValidateButton = false;
  }

  ForgotMessage:boolean=false;
  ForgotMessageContent:string="";

  ForgotPassword() {

    if (this.user.FORGOT_VENDOR_CODE == "" || this.user.FORGOT_VENDOR_CODE == undefined || this.user.FORGOT_VENDOR_CODE == null) {
      this.toastr.error('Please enter the username');
      return;
    }
    this.DisableMailButton = true;
    this.loginSer.ForgotPassword(this.user.FORGOT_VENDOR_CODE).subscribe(
      data => {
       console.log(data);
        if (data.Status) {
          this.DisableMailButton = false;
          this.toastr.success("Password has been sent successfully on the registered mail Id");  
          this.ForgotMessage = true; 
          this.ForgotMessageContent="Password has been sent on the registered mail Id at "+data.Data.USER_EMAIL;
          
        }
        else {
          this.DisableMailButton = false;
          this.toastr.error(data.Message);
        }
      },
      error => {
        this.DisableMailButton = false;
        console.log(error);
        console.error();
      }
    );

  }

  LoginUser() {

    // document.getElementById('btnMSMEModal').click();
    // return;

    this.loginSer.Login(this.user.USER_NAME, this.user.USER_PASSWORD).subscribe(
      data => {

        console.log(data);

        if (data.StatusCode == 200) {
          
          if (this.user.USER_PASSWORD.toLowerCase() == this.user.USER_NAME.toLowerCase()) {
            this.ForgotPassModel.USER_NAME = this.user.USER_NAME;
            this.ForgotPassModel.USER_PASSWORD = this.user.USER_PASSWORD;
            document.getElementById('btnResetPass').click();
            return;
          }

          sessionStorage.setItem("UserName", data.Data["UserMaster"]["USER_NAME"]);
          sessionStorage.setItem("UserRole", data.Data["UserMaster"]["USER_ROLE"]);
          sessionStorage.setItem("UserEmail", data.Data["UserMaster"]["USER_EMAIL"]);
          let role = data.Data["UserMaster"]["USER_ROLE"];
          if (role.toLowerCase() == 'vendor') {

            this.VendorName = data.Data["VendorName"];
            this.VendorPAN = data.Data["VendorPAN"];
            this.FinancialYEar = data.Data["FinancialYEar"];
            this.Declaration = data.Data["DeclarationStatus"];
            this.DeclarationMSME = data.Data["MSMEStatus"];

            if (!this.DeclarationMSME) {             
              document.getElementById('btnMSMEModal').click();
              return;
            }

            //#region  Old
            // if (data.Data["Status"] == true) {
            //   this.router.navigate(['/dashboard'], { replaceUrl: true });
            // }
            // else {
            //   document.getElementById('btnTax').click();
            //   this.Declaration = 'false';
            //   this.VendorName = data.Data["VendorName"];
            //   this.VendorPAN = data.Data["VendorPAN"];
            //   this.FinancialYEar = data.Data["FinancialYEar"];

            // }
            //#endregion



            // if (data.Data["FilePath"] != '')
            //   this.DeclarationFileURL = this.GetCompleteFileURL(data.Data["FilePath"]);
            this.ReasonForRejection = data.Data["ReasonForRejection"];
            if (this.Declaration == "Accepted") {
              this.router.navigate(['/dashboard'], { replaceUrl: true });
              //document.getElementById('btnTax').click();
            }
            else {
              document.getElementById('btnTax').click();
            }
          }
          else {
            this.router.navigate(['/dashboard'], { replaceUrl: true });
          }
        }
        else {
          this.toastr.error(data.Message)
        }
      },
      error => {
        console.log(error);
        console.error();
      }
    );

  }
  Onclick() {
    this.enable = true;
  }
  Onclick2() {
    this.enable = false;
  }

  
msmeUpload:boolean=false;
  public uploadFile = (files) => {
    this.message = 'Uploading please wait...';
    if (files.length === 0) {
      return;
    }
    let filesToUpload: File[] = files;
    const formData = new FormData();
    Array.from(filesToUpload).map((file, index) => {
      return formData.append('file' + index, file, file.name);
    });
    formData.append("PANNo", this.vendorRegModel.PANNo);
    this.http.post(this._CrudSer.siteUrl + 'User/Upload',
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          //alert("Uploaded");
          this.msmeUpload =true;
          this.message = 'Upload success.';
        }
      });
  }

  public panuploadFile = (files) => {
    this.message = 'Uploading please wait...';
    if (files.length === 0) {
      return;
    }
    let filesToUpload: File[] = files;
    const formData = new FormData();
    Array.from(filesToUpload).map((file, index) => {
      return formData.append('file' + index, file, file.name);
    });

    formData.append("PANNo", this.vendorRegModel.PANNo);
    this.http.post(this._CrudSer.siteUrl + 'User/PanUpload/',
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.message = 'Upload success.';
        }
      });
  }

  public chequeuploadFile = (files) => {
    this.message = 'Uploading please wait...';
    if (files.length === 0) {
      return;
    }
    let filesToUpload: File[] = files;
    const formData = new FormData();
    Array.from(filesToUpload).map((file, index) => {
      return formData.append('file' + index, file, file.name);
    });
    formData.append("PANNo", this.vendorRegModel.PANNo);
    this.http.post(this._CrudSer.siteUrl + 'User/ChequeUpload',
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.message = 'Upload success.';
        }
      });
  }

  public registereduploadFile = (files) => {
    this.message = 'Uploading please wait...';
    if (files.length === 0) {
      return;
    }
    let filesToUpload: File[] = files;
    const formData = new FormData();
    Array.from(filesToUpload).map((file, index) => {
      return formData.append('file' + index, file, file.name);
    });
    formData.append("PANNo", this.vendorRegModel.PANNo);
    this.http.post(this._CrudSer.siteUrl + 'User/RegisteredUpload',
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.message = 'Upload success.';
        }
      });
  }

  GetVendorDetails() {

    
    this.loginSer.GetVendorDetails().subscribe(
      res => {

        // alert(res.Data);
        
        //this.StateNavList = res.Data;
        // this.PostCodeList = res.Data[0];
        // this.StateNavList = res.Data[1]
        console.log('GetVendorDetails - success', res)
      },
      error => {
        console.log('GetVendorDetails - error',error);
      }
    );
  }

  GteCityAndStateList() {

    
    this.loginSer.GetCityandState().subscribe(
      res => {

        //alert(res.Data);
        
        this.StateList = res.Data;
        // this.PostCodeList = res.Data[0];
        // this.StateNavList = res.Data[2]
        console.log('GetCityandState - success', res)
      },
      error => {
        console.log('GetCityandState - error',error);
      }
    );
  }

  GetState() {

    
    this.loginSer.GetState().subscribe(
      res => {

        // alert(res.Data);
        
        this.StateNavList = res.Data;
        // this.PostCodeList = res.Data[0];
        // this.StateNavList = res.Data[1]
        console.log('GetState - success', res)
      },
      error => {
        console.log('GetState - error',error);
      }
    );
  }


  GetDepartment() {

    
    this.loginSer.GetDepartmentCode().subscribe(
      res => {

        //alert(res.Data);
        
        this.PostCodeList = res.Data;
        // this.PostCodeList = res.Data[0];
        // this.StateNavList = res.Data[2]
        console.log('GetDepartmentCode - success',res)
      },
      error => {
        console.log('GetDepartmentCode - error',error);
      }
    );
  }


  GetPostCode() {

    
    this.loginSer.GetPostCode().subscribe(
      res => {

        //alert(res.Data);
        
        this.PostCodeList = res.Data;
        // this.PostCodeList = res.Data[0];
        // this.StateNavList = res.Data[2]
        console.log('GetPostCode - success',res)
      },
      error => {
        console.log('GetPostCode - error',error);
      }
    );
  }

  public othersuploadFile = (files) => {
    this.message = 'Uploading please wait...';
    if (files.length === 0) {
      return;
    }
    let filesToUpload: File[] = files;
    const formData = new FormData();
    Array.from(filesToUpload).map((file, index) => {
      return formData.append('file' + index, file, file.name);
    });
    formData.append("PANNo", this.vendorRegModel.PANNo);
    this.http.post(this._CrudSer.siteUrl + 'User/OtherFiles',
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.message = 'Upload success.';
        }
      });
  }


  //#region  TAX Declaration

  Declaration: string = "";
  DeclarationFile: File | null = null;
  DeclarationFileURL: string = "";
  ReasonForRejection: string = "";
  VendorName: string = "";
  VendorPAN: string = "";
  FinancialYEar: string = "";
  

  DeclarationFileInput(files: FileList) {
    this.DeclarationFile = files.item(0);
  }

  GetCompleteFileURL(url: string) {
    

    let fileURL = url.substring(url.indexOf('UPLOADEDFILES'));

    fileURL = this._CrudSer.DownLoadURl + fileURL;

    return fileURL;

  }

  UpdateDeclaration(status: string) {
    
    if (status == 'Yes') {

      const formData: FormData = new FormData();
      formData.append('TDSFile', this.DeclarationFile);
      formData.append("UserName", sessionStorage.getItem("UserName"));
      formData.append("UserEmail", sessionStorage.getItem("UserEmail"));
      formData.append("Status", status);

      this.loginSer.UpdateDeclaration(formData)
        .subscribe(response => {
          console.log(response);
          if (response.Status) {
            document.getElementById('btnCloseTDS').click();
            this.toastr.success('Declaration has been updated.');
            this.router.navigate(['/dashboard'], { replaceUrl: true });
          }
          else {
            this.toastr.error(response.Message);
          }
        });
    }
    else {
      // document.getElementById('btnCloseTDS').click();
      // this.router.navigate(['/dashboard'], { replaceUrl: true });
      this.Declaration = 'No';
    }

  }

  UploadDeclaration() {
    
    if (this.DeclarationFile == null) {
      this.toastr.error("Please Choose File.");
    }
    else {
      const formData: FormData = new FormData();
      formData.append('TDSFile', this.DeclarationFile, this.DeclarationFile.name);
      formData.append("UserName", sessionStorage.getItem("UserName"));
      formData.append("UserEmail", sessionStorage.getItem("UserEmail"));


      this.loginSer.UploadDeclaration(formData)
        .subscribe(response => {
          console.log(response);
          this.TDSFile.nativeElement.value = '';
          this.DeclarationFile = null;
          if (response.Status) {
            this.toastr.success('Declaration has been submitted. Please wait for Approval.');
          }
          else {
            this.toastr.error(response.Message);
          }
        });
    }
  }



  downloadURL(url) {
    var evt = document.createEvent("MouseEvents");
    evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);


    
    var link = <HTMLAnchorElement>document.createElement("a");
    // If you don't know the name or want to use
    // the webserver default set name = ''
    link.setAttribute('download', 'btnDownload');


    link.href = url;
    document.body.appendChild(link);
    link.dispatchEvent(evt);
    // link.click();
    // link.remove();
  };

  //#endregion

  ResetPassword() {   
    if (!this.validateForgotPassword()) {
      this.DisableResetButton=true;
      this.loginSer.ResetPassword(this.ForgotPassModel.USER_NAME, this.ForgotPassModel.USER_PASSWORD, this.Newpassword).subscribe(
        data => {
          if (data.Status) {
            this.DisableResetButton=false;
            this.toastr.success(data.Message);
            this.ForgotPassModel = new UserLoginModel();
            this.Newpassword="";
            //this.LogOut();
          }
          else {
            this.DisableResetButton=false;
            this.toastr.error(data.Message)
          }
        },
        error => {
          this.DisableResetButton=false;
          console.log(error);
          console.error();
        }
      );
    }

  }

  validateForgotPassword(): boolean {
    var result: boolean = false;
    if (this.ForgotPassModel.USER_PASSWORD == "" || this.ForgotPassModel.USER_PASSWORD == undefined || this.ForgotPassModel.USER_PASSWORD == null) {
      this.toastr.warning("Please enter Old Password");
      result = true;
    }
    if (this.ForgotPassModel.USER_CONFIRM_PASSWORD == "" || this.ForgotPassModel.USER_CONFIRM_PASSWORD == undefined || this.ForgotPassModel.USER_CONFIRM_PASSWORD == null) {
      this.toastr.warning("Please enter New Password");
      result = true;
    }

    if (this.Newpassword == "" || this.Newpassword == undefined || this.Newpassword == null) {
      this.toastr.warning("Please enter confirm Password");
      result = true;
    }
    if (this.Newpassword != this.ForgotPassModel.USER_CONFIRM_PASSWORD) {
      this.toastr.warning("Password does not match");
      result = true;
    }
    if (this.Newpassword == this.ForgotPassModel.USER_PASSWORD) {
      this.toastr.warning("Old password and new password can not be same");
      result = true;
    }
    return result;

  }


  notificationList: VMS_Notification[] = [];
  GetPageNotifications(pageId: number) {
    this.notificationSer.GetPageNotifications(0,pageId).subscribe(
      res => {
        console.log('PageNotifications',res);
        this.notificationList = res.Data;
        //document.getElementById('btnNotice').click();
      },
      error => {
        console.log(error);
      }
    );
  }

  CheckAttachmentName(attachName): string {

    if (attachName == '' || attachName == undefined || attachName == null) {
      return '';
    }
    else {
      let li = attachName.indexOf('.');
      let fname = attachName.substring(0, (li - 15));
      const pattern = /_/gi;
      const replacement = " ";
      return fname;
      // return fname.replace(pattern, replacement);
    }
  }


  
  MSMSECertificateFile: File | null = null;
  MSMSECertificateFileURL: string = "";  
  DeclarationMSME: any;
  MSMSECertificateFileInput(files: FileList) {
    this.MSMSECertificateFile = files.item(0);
  }

  MSMETypeChange() {
   
    if (this.vendorRegModel.MSMEType == "Micro" || this.vendorRegModel.MSMEType == "Small"|| this.vendorRegModel.MSMEType == "Medium") {
      this.enable = true;
      this.vendorRegModel.RegisterWith = "true"
    }
    else 
    {
      //this.msmeUpload = false;
      this.enable = false;
      this.msmeUpload = false;
      this.vendorRegModel.RegisterWith = "false"
      this.vendorRegModel.MSMERegistrationDate ="";
      //this.CertificateFile.nativeElement.value = '';

      (<HTMLInputElement>document.getElementById("msmseFile")).value=null;
    }
  }

  SaveMSMEDetails() {

    debugger;

    if (this.vendorRegModel.MSMEType == "Micro" || this.vendorRegModel.MSMEType == "Small" || this.vendorRegModel.MSMEType == "Medium") {
      if (this.vendorRegModel.MSMERegistrationDate == '') {       
        this.toastr.error("Please Enter Registration Date");
       return;
      }
      if (this.MSMSECertificateFile == null) {
        this.toastr.error("Please Choose File.");
        return;
      }
    }


    if (confirm("Do you want to submit MSME Cerficate Type: " + this.vendorRegModel.MSMEType)) {
      this.vendorRegModel.VendorCode = this.user.USER_NAME;
      this.vendorRegModel.PANNo = this.VendorPAN;
      const formData = new FormData();
      formData.append("VendorNo", this.vendorRegModel.VendorCode);
      formData.append("PANNo", this.vendorRegModel.PANNo);
      formData.append("RegDate", this.vendorRegModel.MSMERegistrationDate);
      formData.append("MSMEType", this.vendorRegModel.MSMEType);
      formData.append('CertificateFile', this.MSMSECertificateFile);
      this.loginSer.SaveMSMEDetails(formData).subscribe(response => {

        console.log(response);
        this.CertificateFile.nativeElement.value = '';
        this.MSMSECertificateFile = null;
        if (response.Status) {
          document.getElementById('btnMsmeClose').click();
          this.toastr.success('Your MSME Registration details has been updated.');
          this.router.navigate(['/dashboard'], { replaceUrl: true });
        }
        else {
          this.toastr.error(response.Message);
        }
      });
    }
  }

}



